export default "__VITE_ASSET__ezMvAExT__"